export const UserConstants = {
    Storage: {
        LOCAL_STORAGE_KEY: "relode:v2:user:key",
    },
    Validations: {
        FirstName: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 50,
        },
        LastName: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 50,
        },
        Email: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 300,
        },
        PhoneNumber: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 100,
        },
        Address1: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 200,
        },
        Address2: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 200,
        },
        SecurityStamp: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 500,
        },
        ProfileImageFileKey: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 500,
        },
        Source: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 100,
        },
        Medium: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 100,
        },
        Campaign: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 100,
        },
        Content: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 100,
        },
        Term: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 100,
        },
        FacebookProfileUrl: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 500,
        },
        LinkedInProfileUrl: {
            MIN_LENGTH: 1,
            MAX_LENGTH: 500,
        },
    },
};
